'use strict';

var serverData = (typeof window !== "undefined" ? window.pbizServer : typeof global !== "undefined" ? global.pbizServer : null);

var getTracks = function() {

	return serverData.event.music.tracks;

};

var getTrack = function(id) {

	return getTracks()[id];

};

var getNextTrack = function(curTrack) {

	var numTracks = getTracks().length;

	if (typeof curTrack === 'undefined' || curTrack + 1 === numTracks) {

		return 0;

	} else {

		return curTrack + 1;

	}

};

var hasMusic = function() {

	return !!serverData.event.music;
};

var isAutoPlay = function() {

	return serverData.event.music.isAutoPlay;

};

module.exports = {

	getTrack: getTrack,
	getNextTrack: getNextTrack,
	hasMusic: hasMusic,
	isAutoPlay: isAutoPlay

};
